import { Component, OnInit } from '@angular/core';
import {TendencyReportService} from "../../Services/tendencyReport.service";
import {ActivatedRoute} from "@angular/router";
import * as htmlToImage from 'html-to-image';
import {TranslateService} from "@ngx-translate/core";
declare var $;

@Component({
  selector: 'app-isolated-tendency-report',
  templateUrl: './isolated-tendency-report.component.html',
  styleUrls: ['./isolated-tendency-report.component.css'],
  providers: [TendencyReportService]
})
export class IsolatedTendencyReportComponent implements OnInit {

  reportData: Array<any> = [];
  isDatasetOk: boolean = false;
  noReportData: boolean = false;
  loginMsg: string = '';
  isDataShow:boolean = false;
  radarChartLabels: Array<string> = [];
  screenWidth: number = 1366;
  radarChartData:any = [];
  radarChartType = 'radar';
  redirectUrl: string = '';
  selectedResponseId = '';
  no_of_first_choices = 0;
  no_of_games = 0;
  currentTab;
  isDownload: boolean = false;
  buttonTitle: any;
  reportCountTitle = '';
  myColors = [
    {
      backgroundColor: 'rgba(0,114,188, .1)', // Blue
      borderColor: 'rgb(0,114,188)',
      pointBackgroundColor: 'rgb(0,114,188)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(0,114,188, .8)'
    },{
      backgroundColor: 'rgba(142,198,63, .1)', // Green
      borderColor: 'rgb(142,198,63)',
      pointBackgroundColor: 'rgb(142,198,63)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(142,198,63, .8)'
    },{
      backgroundColor: 'rgba(248,148,30, .1)', // Orange
      borderColor: 'rgb(248,148,30)',
      pointBackgroundColor: 'rgb(248,148,30)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(248,148,30, .8)'
    },{
      backgroundColor: 'rgba(192,40,45, .1)', // Maroon
      borderColor: 'rgb(192,40,45)',
      pointBackgroundColor: 'rgb(192,40,45)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(192,40,45, .8)'
    },{
      backgroundColor: 'rgba(50,50,124, .1)', // Dark Blue
      borderColor: 'rgb(50,50,124)',
      pointBackgroundColor: 'rgb(50,50,124)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(50,50,124, .8)'
    },{
      backgroundColor: 'rgba(0,138,74, .1)', // Dark Green
      borderColor: 'rgb(0,138,74)',
      pointBackgroundColor: 'rgb(0,138,74)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(0,138,74, .8)'
    },{
      backgroundColor: 'rgba(128,0,128, .1)', // Purple
      borderColor: 'rgb(128,0,128)',
      pointBackgroundColor: 'rgb(128,0,128)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(128,0,128, .8)'
    },{
      backgroundColor: 'rgba(255,0,255, .1)', // Fuchsia
      borderColor: 'rgb(255,0,255)',
      pointBackgroundColor: 'rgb(255,0,255)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(255,0,255, .8)'
    },{
      backgroundColor: 'rgba(128,128,0, .1)', // Olive
      borderColor: 'rgb(128,128,0)',
      pointBackgroundColor: 'rgb(128,128,0)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(128,128,0, .8)'
    },{
      backgroundColor: 'rgba(255,0,0, .1)', // Red
      borderColor: 'rgb(255,0,0)',
      pointBackgroundColor: 'rgb(255,0,0)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(255,0,0, .8)'
    },{
      backgroundColor: 'rgba(255,255,0, .1)', // Yellow
      borderColor: 'rgb(255,255,0)',
      pointBackgroundColor: 'rgb(255,255,0)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(255,255,0, .8)'
    },{
      backgroundColor: 'rgba(51,204,255, .1)', // Aqua
      borderColor: 'rgb(51,204,255)',
      pointBackgroundColor: 'rgb(51,204,255)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(51,204,255, .8)'
    }
  ];
  options = {};

  constructor(private tendencyReportService: TendencyReportService, private route: ActivatedRoute, private translateService: TranslateService) {
    let lang_name = localStorage.getItem('defaultLang') ? localStorage.getItem('defaultLang') : 'English';
    this.translateService.reloadLang(lang_name);
  }

  ngOnInit() {
    $(document).ready(function() {
      $("#disablePrevent").on("contextmenu",function(){
        return false;
      });
    });
    $("header").css('display','none');
    $("footer").css('display','none');
    window.name = 'isolatedTendencyReportScreen';
    this.isDataShow = false;
    this.route.params.subscribe(params => {
      if(params['url']){
        let id = params['url'];
        if(id && id.includes('http')){
          this.redirectUrl = decodeURIComponent(id);
        }
      }
    });
    $("#preloader").css('display','block');
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    let Role = localStorage.getItem('userRole');
    if(Role && (Role == 'Learner' || Role == 'Manager')){
      if(currentUser && currentUser.user){
        let lang_name = localStorage.getItem('defaultLang');
        this.translateService.use(lang_name);
        this.translateService.get(['FOOTER.COPY_TEXT', 'TENDENCY_REPORT.ALL_INTERACTION']).subscribe(label => {
          this.buttonTitle = label;
          this.translateService.get(['TENDENCY_REPORT.REPORT_COUNTS']).subscribe(labels => {
            this.reportCountTitle = labels['TENDENCY_REPORT.REPORT_COUNTS'];
            this.setOptions();
            this.generateReport();
            this.isDataShow = true;
          });
        });
      }else{
        this.isDataShow = false;
        $("#preloader").css('display','none');
        this.loginMsg = '200';
        $('#msgModal').modal('show');
      }
    }else{
	    this.isDataShow = false;
        $("#preloader").css('display','none');
        this.loginMsg = '201';
        $('#msgModal').modal('show');
    }
  }

  setOptions(){
    let no_of_first_choices = 0;
    let no_of_games = 0;
    this.screenWidth = screen.width || window.screen.width;
    let curr = this;
    if(this.screenWidth >= 1000){
      this.options = {
        legend: {
          position: 'top',
          fontSize: 16,
          onClick: function(e, legendItem) {
            if(curr.selectedResponseId != ''){
              let ind = curr.reportData.findIndex(obj=> obj.id == curr.selectedResponseId);
              if(ind > -1){
                curr.no_of_first_choices = curr.reportData[ind].no_of_first_choices;
                curr.no_of_games = curr.reportData[ind].no_of_games;
                let index = legendItem.datasetIndex;
                let categoryName = legendItem.text;
                let ci = this.chart;

                let catArr = curr.reportData[ind].category;
                let commCatArr = curr.reportData[ind].commCategory;
                no_of_first_choices = 0;
                no_of_games = 0;
                ci.getDatasetMeta(index).hidden = ci.getDatasetMeta(index).hidden === null ? true : !ci.getDatasetMeta(index).hidden;
                // ci.update();
                let allCatInd = catArr.findIndex(catAll=> catAll.name == curr.buttonTitle['TENDENCY_REPORT.ALL_INTERACTION']);
                let allCatFlag = false;
                let cntAll = 0;
                let deSelectedCatArr = [];
                let selCatArr = [];

                ci.data.datasets.forEach(function(e, i, arr) {
                  let meta = ci.getDatasetMeta(i);
                  // meta.hidden = meta.hidden === null ? true : !meta.hidden;
                  categoryName = meta.label;
                  meta.hidden = meta.hidden === null ? false : meta.hidden;
                  if(allCatInd == i && !meta.hidden){
                    allCatFlag = true;
                  }

                  if(meta.hidden){
                    cntAll += 1;
                    selCatArr.push(e.label);
                  }else{
                    deSelectedCatArr.push(e.label);
                  }

                  if(i == arr.length-1){
                    //All categories are Hidden then count = 0
                    if(cntAll == catArr.length){

                      curr.no_of_first_choices = 0;
                      curr.no_of_games = 0;
                      let str = curr.reportCountTitle.replace('{{firstVal}}', ''+curr.no_of_first_choices).replace('{{secondVal}}', ''+curr.no_of_games);
                      ci.options.title.text = [str , ' ' ];
                      ci.update();

                    }
                    //No category is hidden or only All interaction selected then display total count
                    else if(cntAll == 0 || deSelectedCatArr && deSelectedCatArr.length == 1 && allCatFlag){
                      curr.no_of_first_choices = curr.reportData[ind].no_of_first_choices;
                      curr.no_of_games = curr.reportData[ind].no_of_games;
                      let str = curr.reportCountTitle.replace('{{firstVal}}', ''+curr.no_of_first_choices).replace('{{secondVal}}', ''+curr.no_of_games);
                      ci.options.title.text = [str , ' ' ];
                      ci.update();
                    }

                    else{
                      no_of_first_choices = 0;
                      no_of_games = 0;
                      let deName;
                      deSelectedCatArr.sort();

                      for(let s=0; s < deSelectedCatArr.length; s++){
                        deName = deName + deSelectedCatArr[s] + '*';

                        let cInd = catArr.findIndex(ob=> ob.name == deSelectedCatArr[s]);
                        if(cInd > -1){
                          no_of_first_choices += catArr[cInd].total;
                          no_of_games += catArr[cInd].no_games;
                        }
                      }

                      if(deSelectedCatArr.length > 1){

                        let commonArr = commCatArr.filter(ob=> ob.name.includes('*'));
                        if(commonArr && commonArr.length > 0){

                          let existCnt = 0;

                          for(let t=0; t < commonArr.length; t++){

                            existCnt = 0;

                            for(let u=0; u < deSelectedCatArr.length; u++){

                              if(commonArr[t].name.includes(deSelectedCatArr[u])){
                                existCnt++;
                              }

                            }

                            if(existCnt> 0){

                              no_of_first_choices -= (existCnt * commonArr[t].total)- commonArr[t].total;
                              no_of_games -= (existCnt * commonArr[t].no_games)- commonArr[t].no_games;
                            }

                          }
                        }

                        curr.no_of_first_choices = no_of_first_choices;
                        curr.no_of_games = no_of_games;
                        let str = curr.reportCountTitle.replace('{{firstVal}}', ''+curr.no_of_first_choices).replace('{{secondVal}}', ''+curr.no_of_games);
                        ci.options.title.text = [str , ' ' ];
                        ci.update();

                      }else{
                        curr.no_of_first_choices = no_of_first_choices;
                        curr.no_of_games = no_of_games;
                        let str = curr.reportCountTitle.replace('{{firstVal}}', ''+curr.no_of_first_choices).replace('{{secondVal}}', ''+curr.no_of_games);
                        ci.options.title.text = [str , ' ' ];
                        ci.update();
                      }
                    }
                  }

                });
              }
            }
          },
        },
        title: {
          display: true,
          text: curr.reportCountTitle.replace('{{firstVal}}', ''+curr.no_of_first_choices).replace('{{secondVal}}', ''+curr.no_of_games),// ['Based on '+ curr.no_of_first_choices + ' first choices from '+ curr.no_of_games +' games', ' '],
          position: 'bottom',
          padding: 20,
          fontColor: 'black'
        },
        scale: {
          pointLabels: {
            fontSize: 16,
          },
          ticks: {
            fontSize: 14,
            beginAtZero: true,
            max: 100
          }
        },
        tooltips:{
          enabled:true
        }
      };
    }else{
      this.options = {
        height: 300,
        // maintainAspectRatio: false,
        responsive: true,
        legend: {
          position: 'top',
          fontSize: 12,
          onClick: function(e, legendItem) {
            if(curr.selectedResponseId != ''){
              let ind = curr.reportData.findIndex(obj=> obj.id == curr.selectedResponseId);
              if(ind > -1){
                curr.no_of_first_choices = curr.reportData[ind].no_of_first_choices;
                curr.no_of_games = curr.reportData[ind].no_of_games;
                let index = legendItem.datasetIndex;
                let categoryName = legendItem.text;
                let ci = this.chart;

                let catArr = curr.reportData[ind].category;
                let commCatArr = curr.reportData[ind].commCategory;
                no_of_first_choices = 0;
                no_of_games = 0;
                ci.getDatasetMeta(index).hidden = ci.getDatasetMeta(index).hidden === null ? true : !ci.getDatasetMeta(index).hidden;
                // ci.update();
                let allCatInd = catArr.findIndex(catAll=> catAll.name == curr.buttonTitle['TENDENCY_REPORT.ALL_INTERACTION']);
                let allCatFlag = false;
                let cntAll = 0;
                let deSelectedCatArr = [];
                let selCatArr = [];

                ci.data.datasets.forEach(function(e, i, arr) {
                  let meta = ci.getDatasetMeta(i);
                  // meta.hidden = meta.hidden === null ? true : !meta.hidden;
                  categoryName = meta.label;
                  meta.hidden = meta.hidden === null ? false : meta.hidden;
                  if(allCatInd == i && !meta.hidden){
                    allCatFlag = true;
                  }

                  if(meta.hidden){
                    cntAll += 1;
                    selCatArr.push(e.label);
                  }else{
                    deSelectedCatArr.push(e.label);
                  }

                  if(i == arr.length-1){
                    //All categories are Hidden then count = 0
                    if(cntAll == catArr.length){

                      curr.no_of_first_choices = 0;
                      curr.no_of_games = 0;
                      let str = curr.reportCountTitle.replace('{{firstVal}}', ''+curr.no_of_first_choices).replace('{{secondVal}}', ''+curr.no_of_games);
                      ci.options.title.text = [str , ' ' ];
                      ci.update();

                    }
                    //No category is hidden or only All interaction selected then display total count
                    else if(cntAll == 0 || deSelectedCatArr && deSelectedCatArr.length == 1 && allCatFlag){
                      curr.no_of_first_choices = curr.reportData[ind].no_of_first_choices;
                      curr.no_of_games = curr.reportData[ind].no_of_games;
                      let str = curr.reportCountTitle.replace('{{firstVal}}', ''+curr.no_of_first_choices).replace('{{secondVal}}', ''+curr.no_of_games);
                      ci.options.title.text = [str , ' ' ];
                      ci.update();
                    }

                    else{
                      no_of_first_choices = 0;
                      no_of_games = 0;
                      let deName;
                      deSelectedCatArr.sort();

                      for(let s=0; s < deSelectedCatArr.length; s++){
                        deName = deName + deSelectedCatArr[s] + '*';

                        let cInd = catArr.findIndex(ob=> ob.name == deSelectedCatArr[s]);
                        if(cInd > -1){
                          no_of_first_choices += catArr[cInd].total;
                          no_of_games += catArr[cInd].no_games;
                        }
                      }

                      if(deSelectedCatArr.length > 1){

                        let commonArr = commCatArr.filter(ob=> ob.name.includes('*'));
                        if(commonArr && commonArr.length > 0){

                          let existCnt = 0;

                          for(let t=0; t < commonArr.length; t++){

                            existCnt = 0;

                            for(let u=0; u < deSelectedCatArr.length; u++){

                              if(commonArr[t].name.includes(deSelectedCatArr[u])){
                                existCnt++;
                              }
                            }

                            if(existCnt> 0){

                              no_of_first_choices -= (existCnt * commonArr[t].total)- commonArr[t].total;
                              no_of_games -= (existCnt * commonArr[t].no_games)- commonArr[t].no_games;
                            }
                          }
                        }

                        curr.no_of_first_choices = no_of_first_choices;
                        curr.no_of_games = no_of_games;
                        let str = curr.reportCountTitle.replace('{{firstVal}}', ''+curr.no_of_first_choices).replace('{{secondVal}}', ''+curr.no_of_games);
                        ci.options.title.text = [str , ' ' ];
                        ci.update();

                      }else{
                        curr.no_of_first_choices = no_of_first_choices;
                        curr.no_of_games = no_of_games;
                        let str = curr.reportCountTitle.replace('{{firstVal}}', ''+curr.no_of_first_choices).replace('{{secondVal}}', ''+curr.no_of_games);
                        ci.options.title.text = [str , ' ' ];
                        ci.update();
                      }
                    }
                  }

                });
              }
            }
          },
        },
        title: {
          display: true,
          text: curr.reportCountTitle.replace('{{firstVal}}', ''+curr.no_of_first_choices).replace('{{secondVal}}', ''+curr.no_of_games),// ['Based on '+ curr.no_of_first_choices + ' first choices from '+ curr.no_of_games +' games', ' '],
          position: 'bottom',
          padding: 20,
          fontColor: 'black'
        },
        scale: {
          pointLabels: {
            fontSize: 12,
          },
          ticks: {
            fontSize: 10,
            beginAtZero: true,
            max: 100
          }
        },
        tooltips:{
          enabled:true
        }
      };
    }
  }

  getHrefVal(name){
    return '#' + name;
  }

  collapseTab(name){
    $('.nav-tabs').toggleClass('displayNone');
  }

  addShowClass(i){
    if(i==0){
      return 'show';
    }
  }

  clearReport(){
    this.reportData = [];
    this.loginMsg = '';
    this.radarChartLabels = [];
    this.radarChartData = [];
    this.isDatasetOk = false;
  }

  generateReport(){
    $("#preloader").css('display','block');
    this.noReportData = false;
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    let lang_id = localStorage.getItem('defaultLangId') ? localStorage.getItem('defaultLangId') : 'English';
    let  user_id;
    let  community_id;
    if(currentUser && currentUser.user && (currentUser.user.role == 'Learner' || currentUser.user.role == 'Manager')) {
      user_id = currentUser.user.userid;
      community_id = currentUser.user.community_id;

      let obj = {
        "comm_id" : community_id,
        "user_id": user_id,
        "lang_id": lang_id,
        "allInteraction": this.buttonTitle['TENDENCY_REPORT.ALL_INTERACTION']
      };
      this.tendencyReportService.generateTendencyReport(obj).subscribe(res => {
        if(res.success){
          if(res.data && res.data.length > 0){
            this.getCombinedData(res.data);
          }else{
            this.reportData = [];
            this.noReportData = true;
            $("#preloader").css('display','none');
          }
        }else{
          this.reportData = [];
          this.noReportData = true;
          $("#preloader").css('display','none');
        }
      });
    }else{
      this.isDataShow = false;
      $("#preloader").css('display','none');
      this.loginMsg = '200';
      $('#msgModal').modal('show');
    }
  }

  getCombinedData(data){
    let reportData = JSON.parse(JSON.stringify(data));
    if(reportData && reportData.length > 0){
      let total =0;
      let total1 =0;
      let combinedTotal =0;
      let combinedTotal1 =0;
      let cnt =0;
      let combinedCnt =0;
      let ind;
      for(let a=0; a < reportData.length; a++){
        if(reportData[a].displayRespArr.length == 2){
          total =0;
          total1 =0;
          cnt =0;
          combinedCnt =0;
          combinedTotal =0;
          combinedTotal1 =0;
          for(let b=0; b < reportData[a].category.length; b++){
            if(reportData[a].category[b].name == this.buttonTitle['TENDENCY_REPORT.ALL_INTERACTION']){
              ind = b;
              if(reportData[a].category[b].responses[0].percentage > 0 || reportData[a].category[b].responses[1].percentage > 0){
                combinedTotal += reportData[a].category[b].responses[0].percentage;
                combinedTotal1 += reportData[a].category[b].responses[1].percentage;
                combinedCnt += 1;
              }
            }else{
              if(reportData[a].category[b].responses[0].percentage > 0 || reportData[a].category[b].responses[1].percentage > 0){
                total += reportData[a].category[b].responses[0].percentage;
                total1 += reportData[a].category[b].responses[1].percentage;
                cnt += 1;
              }
            }
          }

          if(total > 0 || total1 > 0){
            if(combinedTotal > 0 || combinedTotal1 > 0){
              let per = Math.round(total/cnt);
              reportData[a].category[ind].responses[0].percentage = Math.round((per + combinedTotal)/2);
              let per1 = Math.round(total1/cnt);
              reportData[a].category[ind].responses[1].percentage = Math.round((per1 + combinedTotal1)/2);
            }else{
              reportData[a].category[ind].responses[0].percentage = Math.round(total/cnt);
              reportData[a].category[ind].responses[1].percentage = Math.round(total1/cnt);
            }
          }else{
            if(combinedTotal > 0 || combinedTotal1 > 0){
              reportData[a].category[ind].responses[0].percentage = combinedTotal;
              reportData[a].category[ind].responses[1].percentage = combinedTotal1;
            }else{
              reportData[a].category[ind].responses[0].percentage = 0;
              reportData[a].category[ind].responses[1].percentage = 0;
            }
          }

          if(a == reportData.length-1){
            this.reportData = JSON.parse(JSON.stringify(reportData));
            this.noReportData = false;
            $("#preloader").css('display','none');
          }
        }else if(reportData[a].displayRespArr.length == 3){
          total =0;
          let total1 =0;
          let total2 =0;
          cnt =0;
          combinedCnt =0;
          combinedTotal = 0;
          let combinedTotal1 =0;
          let combinedTotal2 =0;

          for(let b=0; b < reportData[a].category.length; b++){
            if(reportData[a].category[b].name == this.buttonTitle['TENDENCY_REPORT.ALL_INTERACTION']){
              ind = b;
              if(reportData[a].category[b].responses[0].percentage > 0 || reportData[a].category[b].responses[1].percentage > 0 || reportData[a].category[b].responses[2].percentage > 0){
                combinedTotal += reportData[a].category[b].responses[0].percentage;
                combinedTotal1 += reportData[a].category[b].responses[1].percentage;
                combinedTotal2 += reportData[a].category[b].responses[2].percentage;
                combinedCnt += 1;
              }
            }else{
              if(reportData[a].category[b].responses[0].percentage > 0 || reportData[a].category[b].responses[1].percentage > 0 || reportData[a].category[b].responses[2].percentage > 0){
                total += reportData[a].category[b].responses[0].percentage;
                total1 += reportData[a].category[b].responses[1].percentage;
                total2 += reportData[a].category[b].responses[2].percentage;
                cnt += 1;
              }
            }
          }


          if(total > 0 || total1 > 0 || total2 > 0){
            if(combinedTotal > 0 || combinedTotal1 > 0 || combinedTotal2 > 0){
              let per = Math.round(total/cnt);
              reportData[a].category[ind].responses[0].percentage = Math.round((per + combinedTotal)/2);
              let per1 = Math.round(total1/cnt);
              reportData[a].category[ind].responses[1].percentage = Math.round((per1 + combinedTotal1)/2);
              let per2 = Math.round(total2/cnt);
              reportData[a].category[ind].responses[2].percentage = Math.round((per2 + combinedTotal2)/2);
            }else{
              reportData[a].category[ind].responses[0].percentage = Math.round(total/cnt);
              reportData[a].category[ind].responses[1].percentage = Math.round(total1/cnt);
              reportData[a].category[ind].responses[2].percentage = Math.round(total2/cnt);
            }
          }else{
            if(combinedTotal > 0 || combinedTotal1 > 0 || combinedTotal2 > 0){
              reportData[a].category[ind].responses[0].percentage = combinedTotal;
              reportData[a].category[ind].responses[1].percentage = combinedTotal1;
              reportData[a].category[ind].responses[2].percentage = combinedTotal2;
            }else{
              reportData[a].category[ind].responses[0].percentage = 0;
              reportData[a].category[ind].responses[1].percentage = 0;
              reportData[a].category[ind].responses[2].percentage = 0;
            }
          }

          if(a == reportData.length-1){
            this.reportData = JSON.parse(JSON.stringify(reportData));
            this.noReportData = false;
            $("#preloader").css('display','none');
          }
        }else{
          if(a == reportData.length-1){
            this.reportData = JSON.parse(JSON.stringify(reportData));
            this.noReportData = false;
            $("#preloader").css('display','none');
          }
        }
      }
    }else{
      this.reportData = JSON.parse(JSON.stringify(reportData));
      this.noReportData = true;
      $("#preloader").css('display','none');
    }
  }

  generateDataSets(a){
    this.isDatasetOk = false;
    this.radarChartLabels = [];
    this.radarChartData = [];
    this.selectedResponseId = '';
    this.no_of_first_choices = 0;
    this.no_of_games = 0;
    this.currentTab = a;
    $("#preloader").css('display','block');
    for(let s=0; s< this.reportData.length; s++){
      $('#'+ this.reportData[s].id).css('display','none');
    }
    if(!($('#'+ this.reportData[a].id).hasClass("show"))){
      if(this.reportData && this.reportData.length > 0){
        if(this.reportData[a].displayRespArr && this.reportData[a].displayRespArr.length == 3){
          $('.noteToolTipText').removeClass('hidenoteToolTip');
          this.selectedResponseId = this.reportData[a].id;
          this.no_of_first_choices = this.reportData[a].no_of_first_choices;
          this.no_of_games = this.reportData[a].no_of_games;
          if(this.reportData[a].category && this.reportData[a].category.length > 0) {
            for (let b = 0; b < this.reportData[a].displayRespArr.length; b++) {
              if(this.reportData[a].displayRespArr[b].name && this.reportData[a].displayRespArr[b].name.includes(' ')){
                let arr = this.reportData[a].displayRespArr[b].name.split(' ');
                this.radarChartLabels.push(arr);
              }else{
                this.radarChartLabels.push(this.reportData[a].displayRespArr[b].name);
              }
            }
            for(let c=0; c < this.reportData[a].category.length; c++){

              let obj = {
                data: [],
                label: this.reportData[a].category[c].name
              };
              for(let d=0; d < this.reportData[a].category[c].responses.length; d++){
                obj.data.push(this.reportData[a].category[c].responses[d].percentage);
                if(d == this.reportData[a].category[c].responses.length-1){
                  if(this.radarChartData && this.radarChartData.length > 0){
                    let e= this.radarChartData.findIndex(result=>result.labels == this.reportData[a].category[c].name);
                    if(e > -1){
                      this.radarChartData[e].data = JSON.parse(JSON.stringify(obj.data));
                      if(c == this.reportData[a].category.length-1){
                        this.isDatasetOk = true;
                        $('#'+ this.reportData[a].id).css('display','block');
                        if(this.radarChartData && this.radarChartData.length > 0){
                          this.setOptions();
                          $("#preloader").css('display','none');
                        }
                      }
                    }else{
                      this.radarChartData.push(obj);
                      if(c == this.reportData[a].category.length-1){
                        this.isDatasetOk = true;
                        $('#'+ this.reportData[a].id).css('display','block');
                        if(this.radarChartData && this.radarChartData.length > 0){
                          this.setOptions();
                          $("#preloader").css('display','none');
                        }
                      }
                    }
                  }else{
                    this.radarChartData.push(obj);
                    if(c == this.reportData[a].category.length-1){
                      this.isDatasetOk = true;
                      $('#'+ this.reportData[a].id).css('display','block');
                      if(this.radarChartData && this.radarChartData.length > 0){
                        this.setOptions();
                        $("#preloader").css('display','none');
                      }
                    }
                  }
                }
              }
            }
          }else{
            // this.isDatasetOk = true;
            $('#'+ this.reportData[a].id).css('display','none');
            $("#preloader").css('display','none');
          }
        }else{
          // this.isDatasetOk = true;
          $('#'+ this.reportData[a].id).css('display','block');
          $("#preloader").css('display','none');
        }
      }else{
        $('#'+ this.reportData[a].id).css('display','none');
        $("#preloader").css('display','none');
      }
    }else{
      $('#'+ this.reportData[a].id).css('display','none');
      $("#preloader").css('display','none');
    }
  }

  getUniqueId(id){
    return 'myCanvas' + id;
  }

  closeMsgModal(){
    this.loginMsg = '';
    this.clearReport();
    $('#msgModal').modal('hide');
    if(this.redirectUrl != ''){
      location.replace(this.redirectUrl);
    }else{
      window.close();
    }
  }

  downloadImage(resp_id, totalRes) {
    this.isDownload = true;
    $("#preloader").css('display','block');
    let curr = this;
    if(totalRes == 2){
      let id = "myCanvas"+resp_id;
      setTimeout(()=>{
        htmlToImage.toJpeg(document.getElementById(id), { quality: 0.95 })
          .then(function (dataUrl) {
            var link = document.createElement('a');
            link.download = 'my-image-name.jpeg';
            link.href = dataUrl;
            link.click();
            setTimeout(()=>{
              curr.isDownload = false;
              $("#preloader").css('display','none');
            }, 500);
          });
      }, 1500);
    } else if(totalRes == 3){
      let footerText = '© ' + curr.buttonTitle['FOOTER.COPY_TEXT'];
      setTimeout(()=>{
        let id = "myCanvas"+resp_id;
        let canvas = <HTMLCanvasElement> document.getElementById(id);
        var w = canvas.width;
        var h = canvas.height;
        var data;
        var context = canvas.getContext("2d");
        data = context.getImageData(0, 0, w, h);
        var compositeOperation = context.globalCompositeOperation;
        context.globalCompositeOperation = "destination-over";
        context.fillStyle = '#ffffff';
        context.fillRect(0,0,w,h);

        // var image_data = canvas.toDataURL("image/png");
        var image_data = curr.watermarkedDataURL(canvas,footerText);
        context.clearRect (0,0,w,h);
        context.putImageData(data, 0,0);
        context.globalCompositeOperation = compositeOperation;
        if(window.navigator.msSaveBlob){
          window.navigator.msSaveBlob(canvas.msToBlob(), "tendencyReport.png");
          setTimeout(()=>{
            curr.isDownload = false;
            $("#preloader").css('display','none');
          }, 1000);
        } else {
          const a = document.createElement("a");
          document.body.appendChild(a);
          a.href = image_data;
          a.download = "tendencyReport.png";
          a.click();
          document.body.removeChild(a);
          setTimeout(()=>{
            curr.isDownload = false;
            $("#preloader").css('display','none');
          }, 1000);
        }
      }, 1000);
    }else{
      curr.isDownload = false;
      $("#preloader").css('display','none');
    }
  }

  watermarkedDataURL(canvas,text){
    let tempCanvas = document.createElement('canvas');
    let tempCtx = tempCanvas.getContext('2d');
    let cw, ch;
    let heighttext = this.screenWidth >= 1000 ? "11px verdana" : "15px verdana";
    let heightFillText = this.screenWidth >= 1000 ? 2 : 5;
    cw = tempCanvas.width = canvas.width;
    ch = tempCanvas.height = canvas.height;
    tempCtx.drawImage(canvas, 0, 0);
    tempCtx.font = heighttext;
    let textWidth = tempCtx.measureText(text).width;
    // tempCtx.globalAlpha=.50;
    tempCtx.fillStyle = '#000000';
    tempCtx.fillText(text, cw/2 - textWidth/2, ch-heightFillText);
    /* tempCtx.fillStyle='black';
     tempCtx.fillText(text,cw-textWidth-10+2,ch-20+2);*/
    // just testing by adding tempCanvas to document
    //document.body.appendChild(tempCanvas);
    return(tempCanvas.toDataURL("image/png"));
  }

  dismissNoteToolTip() {
    $('.noteToolTipText').addClass('hidenoteToolTip');
  }

  getAvgFor2Resp(val){
    let result = 100 - val;
    return (result - 2);
  }
}



// WEBPACK FOOTER //
// ./src/app/Screens/isolated-tendency-report/isolated-tendency-report.component.ts